import type { ClientToServer, ServerToClient, KnowledgeBase } from "@lupp/shared";
import { getSocket } from "./socket";

/** Holt die dem User zur Verfügung stehenden OWUI-Wissensbasen (über das Backend). */
export async function fetchKnowledgeBases(): Promise<KnowledgeBase[]> {
  const socket = getSocket();

  return new Promise<KnowledgeBase[]>((resolve, reject) => {
    const onEvent = (event: ServerToClient): void => {
      if (event.type === "knowledge_list_result") {
        cleanup();
        resolve(event.collections);
      } else if (event.type === "auth_required") {
        cleanup();
        reject(new Error("auth required"));
      } else if (event.type === "error") {
        cleanup();
        reject(new Error(event.message));
      }
    };

    const cleanup = (): void => {
      socket.off("event", onEvent as Parameters<typeof socket.off>[1]);
    };

    socket.on("event", onEvent as Parameters<typeof socket.on>[1]);
    socket.emit("knowledge_list", { type: "knowledge_list" } satisfies ClientToServer);
  });
}
